module.exports = __webpack_public_path__ + "img/img64.f62dfbb3.svg";